import cn from 'classnames';
import { HTMLAttributes } from 'react';
import styles from './badge.module.scss';


export type BadgeVariant = 'success' | 'destructive' | 'warning' | 'neutral';


export interface BadgeProps extends HTMLAttributes<HTMLDivElement> {
    variant?: BadgeVariant;
}


export function Badge ({ className, variant = 'success', ...props }: BadgeProps) {
    return (
        <div
            className={ cn(styles.badge, styles[`badge--${ variant }`], className) }
            { ...props }
        />
    );
}
